import { render, staticRenderFns } from "./Logos.vue?vue&type=template&id=65eb2fad&scoped=true"
import script from "./Logos.vue?vue&type=script&lang=ts"
export * from "./Logos.vue?vue&type=script&lang=ts"
import style0 from "./Logos.vue?vue&type=style&index=0&id=65eb2fad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eb2fad",
  null
  
)

export default component.exports